import { apiClient } from '@/shared/api';
import type {
  AttendanceDaySchedule,
  CreateDayScheduleRequest,
  UpdateDayScheduleRequest,
} from '@aegislab/shared';

export type { AttendanceDaySchedule, CreateDayScheduleRequest, UpdateDayScheduleRequest };

const BASE = '/attendance/day-schedules';

/** 그 달 전체 — 달력 셀의 점을 찍는 데 쓴다. */
export const fetchDaySchedulesByMonth = async (month: string): Promise<AttendanceDaySchedule[]> => {
  const response = await apiClient.get<AttendanceDaySchedule[]>(BASE, { params: { month } });
  return response.data;
};

/** 그 날 목록 — 서랍이 쓴다. */
export const fetchDaySchedulesByDate = async (date: string): Promise<AttendanceDaySchedule[]> => {
  const response = await apiClient.get<AttendanceDaySchedule[]>(BASE, { params: { date } });
  return response.data;
};

export const createDaySchedule = async (
  input: CreateDayScheduleRequest
): Promise<AttendanceDaySchedule> => {
  const response = await apiClient.post<AttendanceDaySchedule>(BASE, input);
  return response.data;
};

export const updateDaySchedule = async (
  id: string,
  input: UpdateDayScheduleRequest
): Promise<AttendanceDaySchedule> => {
  const response = await apiClient.patch<AttendanceDaySchedule>(`${BASE}/${id}`, input);
  return response.data;
};

export const deleteDaySchedule = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
